import React, {Component} from 'react';
import {Switch, Route, withRouter, Redirect} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import CONFIG from './../../SYSTEM/Config.js'
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { MultiSelect } from "react-multi-select-component";

import { Request } from "./../../SYSTEM/Request"

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';

import Header from './../../APP/COMPONENTS/Header';
import LeftNav from './../../APP/COMPONENTS/LeftNav';
import Loader from './../../APP/COMPONENTS/Loader';

function mapStateToProps(state, myProps) {
    return {
        USER: state.USER
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}


class Products extends Component {
	constructor(props)
    {
        super(props);
        this.state = {
            USER: this.props.USER,
            LOADED: false,
            PRODUCTS: false,
            GROUPS: false,
            FILTER: {
                TITLE: '',
                GROUP: [],
                ARCHIVE: 0,
                DISABLED: 0,
                OUTOFSTOCK: 0,
                MY: 0
            },
            OWN_PRICE: false
        }
    }

    componentDidMount = () =>
    {
        this.fetchProducts();
    }


    componentDidUpdate(prevProps, prevState, snapshot)
    {

        if (this.props.USER !== prevProps.USER) {
            this.setState({USER: this.props.USER});
        }
    }

    fetchProducts = async () =>
    {
        try {
            let SEND_DATA = {
                action:     'supplierProductsAll',
                supplier_apikey: this.props.USER.supplier_apikey
            };

            let data = await Request(SEND_DATA,CONFIG.API_GATE);
            if (data !== false) {
                let FILTER = this.state.FILTER
                FILTER.GROUP = this.getSupplierGroupsToSelect(data.groups)
                this.setState({PRODUCTS: data.products, GROUPS: data.groups, LOADED: true, FILTER: FILTER});
            } else {
                this.setState({LOADED: true});
            }
        } catch (error) {
            console.log(error)
        }
    }

    getSupplierGroupsToSelect = (FETCHED_GROUPS) =>
    {
        let GROUPS = [];

        for (let i = 0; i < this.state.USER.category.length; i++) {
            let GROUP = false;

            for (let j = 0; j <FETCHED_GROUPS.length; j++) {
                if (FETCHED_GROUPS[j].id.toString() == this.state.USER.category[i].toString()) {
                    GROUP = { label: FETCHED_GROUPS[j].title, value: FETCHED_GROUPS[j].id }
                }
            }

            if (GROUP) {
                GROUPS.push(GROUP);
            }
        }

        return GROUPS
    }

    renderProducts = () =>
    {
        if (this.state.LOADED) {
            if (this.state.PRODUCTS) {
                let PRODUCTS = this.filterProducts();
                let TBODY = this.renderProductsRows(PRODUCTS);
                let HEADER = this.renderProductsTableHeader();

                return (
                    <div className="table_holder">
                        <table id="products_table" className="products_table" cellPadding="0" cellSpacing="0">
                            {HEADER}
                            {TBODY}
                        </table>
                        <table id="products_table_saveable" className="products_table_saveable" cellPadding="0" cellSpacing="0">
                            {this.renderProductsTableHeader(true)}
                            {this.renderProductsRows(PRODUCTS, true)}
                        </table>                        
                    </div>
                );
            } else {
                return <div className="table_holder"><h3>Мы не нашли ваших товаров в базе</h3></div>;
            }
        } else {
            return <div className="table_holder"><Loader /><div className="loader_content">Собираем статистику по товарам ...</div></div>
        }
    }

    renderImage = (PRODUCT) =>
    {
        let SRC = PRODUCT.images.thumb;
        if ((typeof SRC !== "undefined") && (SRC !== "")) {
            return (
                <img
                    className="product_image"
                    src={CONFIG.API_C_DOMAIN + SRC}
                />
            );
        }

        return false;
    }

    getProductGroups = (PRODUCT) =>
    {
        let GROUPS = [];
        for (let i = 0; i < PRODUCT.groups.length; i++) {
            let GROUP = false;

            for (let j = 0; j < this.state.GROUPS.length; j++) {
                if (this.state.GROUPS[j].id.toString() == PRODUCT.groups[i].toString()) {
                    GROUP = this.state.GROUPS[j].title;
                }
            }

            if (GROUP) {
                GROUPS.push(<span key={i} className="group_title">{GROUP}</span>);
            }
        }

        return GROUPS;
    }

    renderProductStatuses = (PRODUCT) =>
    {
        let STATUSES = [];
        if (parseInt(PRODUCT.archive) == 1) {
            STATUSES.push(
                <span key="archive" className="archive_label">Архив</span>
            );
        }
        if (parseInt(PRODUCT.disabled) == 1) {
            STATUSES.push(
                <span key="disabled" className="disabled_label">Отключен</span>
            );
        }

        if (STATUSES.length) {
            return (
                <div className="product_title_labels">
                    {STATUSES}
                </div>
            );
        }

        return '';
    }

    addIncomingClassToCell = (DATE) =>
    {
        if (DATE) {
            return ' coming_soon_cell';
        }

        return '';
    }

    addAmountClassToCell = (AMOUNT) =>
    {
        if (parseInt(AMOUNT) == 0) {
            return ' out_of_stock_cell';
        }

        return '';
    }

    renderProductsRows = (PRODUCTS, SAVEABLE) =>
    {
        let ROWS = [];
        for (let i = 0; i < PRODUCTS.length; i++) {
            let PRODUCT = PRODUCTS[i];

            ROWS.push(
                <tr key={i}>
                    {(typeof SAVEABLE !== "undefined") ? false : <td className="cell-center">{this.renderImage(PRODUCT)}</td>}
                    <td><span className="product_title">{PRODUCT.title}{this.renderProductStatuses(PRODUCT)}</span></td>
                    <td className="no_mobile">{this.getProductGroups(PRODUCT)}</td>
                    <td className={"cell-center" + this.addAmountClassToCell(PRODUCT.amount)}>{PRODUCT.amount}</td>
                    <td className="cell-center">{PRODUCT.ed_izm}</td>
                    <td className={"cell-center" + this.addIncomingClassToCell(PRODUCT.incoming_date)}>{PRODUCT.incoming_date}</td>
                    <td className="cell-center">{PRODUCT.sales.ten}</td>
                    {(typeof SAVEABLE !== "undefined") ? false : <td className="cell-center"><a className="my_own_price" onClick={() => this.props.setOwnPrice(PRODUCT)}>Предложить цену</a></td>}
                </tr>
            );
        }

        return (
            <tbody>
                {ROWS}
            </tbody>
        );
    }

    renderProductsTableHeader = (SAVEABLE) =>
    {
        return (
            <thead>
                <tr>
                    {(typeof SAVEABLE !== "undefined") ? false : <th>фото</th>}
                    <th>наименование</th>
                    <th className="no_mobile">категории</th>
                    <th>кол-во<br/>МСК</th>
                    <th>единица<br/>измерения</th>
                    <th>дата<br/>п-ния</th>
                    <th>продажи<br/>за 10д</th>
                    {(typeof SAVEABLE !== "undefined") ? false : <th></th>}
                </tr>
            </thead>
        );
    }

    renderFiter = () =>
    {
        return (
            <div className="filter_head">
                <h1>Тендер</h1>
                {this.renderSearchInput()}
                {this.renderGroupSelect()}
                {this.renderCheckboxes()}
                {this.renderXlsSaveButton()}
            </div>
        );
    }

    appendFilter = (data, type) => {
        let FILTER = this.state.FILTER;
        if (type == 'GROUP') {
            let value = data.target.value;
            if (value == 0) {
                value = '';
            }
            FILTER[type] = value;
        } else if (type == 'OUTOFSTOCK') {
            FILTER[type] = !this.state.FILTER.OUTOFSTOCK;
        } else if (type == 'MY') {
            FILTER[type] = !this.state.FILTER.MY;
        } else {
            FILTER[type] = data.target.value;
        }

        this.setState({FILTER: FILTER});
    }

    filterProducts = () => {
        let FILTER_RESULTS = [];
        let STRING = '';
        let COMPARE = '';

        for (let i = 0; i < this.state.PRODUCTS.length; i++) {
            
            let PRODUCT = this.state.PRODUCTS[i];

            let FOUND = true;

            if (FOUND) {
                if (this.state.FILTER.OUTOFSTOCK == 1) {
                    if (parseInt(PRODUCT.amount) == 0) {
                        FOUND = true;
                    } else {
                        FOUND = false;
                    }
                }
            }

            if (FOUND) {
                if (this.state.FILTER.MY == 1) {
                    if (PRODUCT.my) {
                        FOUND = true;
                    } else {
                        FOUND = false;
                    }
                }
            }

            if (FOUND) {
                if (this.state.FILTER.GROUP.length) {
                    let LOCAL_FOUND = false;
                    for (let i = 0; i < this.state.FILTER.GROUP.length; i++) {
                        if (PRODUCT.groups.indexOf(this.state.FILTER.GROUP[i].value.toString()) >= 0) {
                            LOCAL_FOUND = true
                        }
                    }

                    if (! LOCAL_FOUND) {
                        FOUND = false;
                    } else {
                        FOUND = true;
                    }
                }
            }

            if (FOUND) {
                if (this.state.FILTER.TITLE !== '') {
                    STRING = PRODUCT.title.toUpperCase();
                    COMPARE = this.state.FILTER.TITLE.toUpperCase();

                    if (STRING.indexOf(COMPARE) !== -1) {
                        FOUND = true;
                    } else {
                        FOUND = false;
                    }
                }
            }

            if (FOUND) {
                FILTER_RESULTS.push(PRODUCT);
            }
        }
        return FILTER_RESULTS;

    }

    renderSearchInput = () =>
    {
        if (this.state.LOADED) {
            return (
                <div className="filter_inputs_holder">
                    <div className="filter_element">
                        <input
                            type="text"
                            placehodler="Поиск"
                            value={this.state.FILTER.TITLE}
                            onChange={(text) => this.appendFilter(text, 'TITLE')} 
                        />
                        <img className="search_icon" src="/system_images/search_icon.png" />
                    </div>
                </div>
            );
        }
    }

    renderXlsSaveButton = () =>
    {
        if (this.state.LOADED) {
            return (
                <ReactHTMLTableToExcel
                    id="products_table_btn"
                    className="filter_btn"
                    table="products_table_saveable"
                    filename="tablexls"
                    sheet="ecomarket_products"
                    buttonText="Сохранить в XLS"
                />
            );
        }
    }

    renderCheckboxes = () =>
    {
        if (this.state.LOADED) {
            return (
                <>
                    <div className="filter_inputs_holder">
                        <input
                            type="checkbox"
                            id="outofstock"
                            name="outofstock"
                            value="1"
                            checked={this.state.FILTER.OUTOFSTOCK}
                            onChange={(input) => {this.appendFilter(input, 'OUTOFSTOCK')}}
                        />
                        <label htmlFor="outofstock">
                            <span></span>
                            Нет в наличии
                        </label>
                    </div>
                    <div className="filter_inputs_holder">
                        <input
                            type="checkbox"
                            id="my"
                            name="my"
                            value="1"
                            checked={this.state.FILTER.MY}
                            onChange={(input) => {this.appendFilter(input, 'MY')}}
                        />
                        <label htmlFor="my">
                            <span></span>
                            Мои товары
                        </label>
                    </div>
                </>
            );
        }
    }

    compare = ( a, b ) => {
        if ( a.title < b.title ){
          return -1;
        }
        if ( a.title > b.title ){
          return 1;
        }
        return 0;
    }

    setSelected = (options) =>
    {
        let FILTER = this.state.FILTER;
        FILTER.GROUP = options
        this.setState({FILTER: FILTER})
    }

    renderGroupSelect = () =>
    {
        if ((this.state.LOADED) && (this.state.GROUPS)) {
            let OPTIONS = [];

            let GROUPS = this.state.GROUPS
            GROUPS.sort(this.compare);

            for (let i = 0; i < GROUPS.length; i++) {
                let OPT = GROUPS[i];
                OPTIONS.push({ label: OPT.title, value: OPT.id });
            }

            return (
                <div className="filter_inputs_holder">
                    <div className="filter_element">
                        <MultiSelect
                            options={OPTIONS}
                            hasSelectAll={false}
                            value={this.state.FILTER.GROUP}
                            onChange={this.setSelected}
                            labelledBy="Выбрать"
                            overrideStrings={{
                                allItemsAreSelected: 'Все варианты выбраны',
                                clearSearch: 'Очистить поиск',
                                clearSelected: 'Сбросить выбор',
                                noOptions: 'Нет вариантов',
                                search: 'Поиск...',
                                selectSomeItems: 'Выбрать...'
                            }}
                        />
                    </div>
                </div>
            );
        }
    }

    render() {
        if (!this.state.USER) {
            return <Redirect to="/"/>
        }

        return (
            <div className="main_content">
                <Helmet>
                    <title>Тендер</title>
                </Helmet>
                {this.renderFiter()}
                {this.renderProducts()}
            </div>
        );
	}
}

export default withRouter(connect(
	mapStateToProps, mapDispatchToProps
)(Products))
